"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = exports.IconDataTids = exports.DEFAULT_ICON_WEIGHT = exports.DEFAULT_ICON_SIZE = exports.MAX_SOLID_POSITION = exports.MAX_REGULAR_POSITION = exports.MAX_LIGHT_POSITION = exports.weights = exports.breakpoints = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var getIconPosition_1 = require("./getIconPosition");
var correctIconPosition_1 = require("./correctIconPosition");
exports.breakpoints = [16, 20, 24, 32, 64];
exports.weights = ['light', 'regular', 'solid'];
exports.MAX_LIGHT_POSITION = 1;
exports.MAX_REGULAR_POSITION = 4;
exports.MAX_SOLID_POSITION = 2;
exports.DEFAULT_ICON_SIZE = 16;
exports.DEFAULT_ICON_WEIGHT = 'regular';
exports.IconDataTids = {
    root: 'Icon__root',
};
exports.Icon = react_1.forwardRef(function (_a, ref) {
    var sizes = _a.sizes, style = _a.style, _b = _a.size, size = _b === void 0 ? exports.DEFAULT_ICON_SIZE : _b, _c = _a.weight, weight = _c === void 0 ? exports.DEFAULT_ICON_WEIGHT : _c, _d = _a.align, align = _d === void 0 ? 'center' : _d, color = _a.color, rest = tslib_1.__rest(_a, ["sizes", "style", "size", "weight", "align", "color"]);
    var iconPosition = getIconPosition_1.getIconPosition(size, exports.breakpoints);
    var correctedPosition = correctIconPosition_1.correctIconPosition(iconPosition, weight);
    var viewBoxSize = exports.breakpoints[correctedPosition];
    var Icon = sizes[viewBoxSize][weight];
    return (react_1.default.createElement(Icon, tslib_1.__assign({ ref: ref, style: style, size: size, viewBoxSize: viewBoxSize, weight: weight, color: color, align: align }, rest)));
});
exports.Icon.displayName = 'Icon';
